<template>
  <div class="docs-content">
    <div class="docs-content-left">
      <div class="docs-content-left-title" v-show="categoryInfo">
        <span><Icon type="file"/></span>
        <strong>{{ categoryInfo.name }}</strong>
      </div>
      <div class="docs-content-search">
        <a-input-search
          placeholder="input search text"
          @search="onSearch"
          @change="onChange"
          style="flex:1;"
        />
        <!-- 添加 -->
        <span>
          <router-link
            :to="{
              name: 'DocsPropsAdd',
            }"
            v-if="AUTH_DOCS_ADD"
          >
            <Icon type="add" />
          </router-link>
        </span>
      </div>
      <div class="docs-content-list">
        <ul>
          <li
            v-for="(item, index) in list"
            :key="item.id + '_' + index"
            :class="item.id == id ? 'active' : ''"
          >
            <span @click="getDetail(item.id)">
              <DocsStatus :status="item.enable" size="small" />{{ item.title }}
            </span>
            <!-- 右键 -->
            <ContextMenu :list="operationList(item)" />
          </li>
        </ul>
        <Empty
          v-if="!(list && list.length > 0)"
          textStyle="font-size: 12px; font-weight: normal;margin-top: 10px;"
        />
      </div>
    </div>
    <div class="docs-content-right">
      <Loading :show="true" v-if="loadingContent" />
      <a-form-model
        :model="form"
        ref="documentForm"
        style="width: 100%;"
        v-show="!loadingContent && detail"
      >
        <div class="docs-content-title">
          <h3>
            {{ detail?.title }}
          </h3>
          <div class="docs-content-title-action">
            <a-button
              type="default"
              @click="
                () => {
                  this.$router.go(-1);
                }
              "
            >
              {{ $t('docs_return_list') }}
            </a-button>

            <a-button
              type="default"
              @click="
                () => {
                  this.$refs.share.show(true, detail);
                }
              "
              >{{ $t('com_btn_share') }}
            </a-button>
            <a-button
              type="primary"
              @click="
                () => {
                  save();
                }
              "
              v-if="detail && hasWritePermissioin"
              >{{ $t('com_btn_update') }}</a-button
            >
          </div>
        </div>
        <div class="docs-content-content" v-if="hasWritePermissioin">
          <a-form-model-item
            :label="null"
            prop="content"
            class="docs-content-tinymce"
            style="margin-bottom: 0;"
          >
            <Tinymce
              v-model="form.content"
              @change="
                value => {
                  form.content = value;
                }
              "
              height="600"
              style="margin-top:8px;height:100%"
            />
          </a-form-model-item>
        </div>
        <NoAuth v-else />.
      </a-form-model>
    </div>

    <!-- 分享 -->
    <Share ref="share" v-if="detail" />
  </div>
</template>
<script>
import ContextMenu from '@/components/ContextMenu';
import * as DocsAPI from '@/api/docs';
import docsOperations from '@/views/docs/mixins/operations';
import Share from '@/views/docs/components/Share';
import { mapState } from 'vuex';
import { hasReadWritePermission } from '@/libs/permissions';
import docsAuth from '@/views/docs/mixins/docsAuth';
import { generateSignedUrl } from '@/config/oss';
import DocsStatus from '@/views/docs/components/DocStatus';

export default {
  mixins: [docsOperations, docsAuth],
  components: {
    ContextMenu,
    Share,
    DocsStatus,
  },
  data() {
    return {
      // 从URL获取category id和document id
      id: this.$route.params.id,
      categoryId: this.$route.params.categoryId,
      // 表单
      form: {
        content: undefined,
      },

      // detail
      detail: null,
      // 文档列表
      list: null,
      // 当前分类
      categoryInfo: null,

      loadingContent: true,
    };
  },
  created() {
    this.getData();
  },
  computed: {
    ...mapState(['userInfo']),
    // 是否有数据编辑（包括删除、禁用等）权限
    hasWritePermissioin() {
      return (
        this.AUTH_DOCS_CONTENT_EDIT &&
        hasReadWritePermission('write', 'wiki', this.detail?.writeLevel)
      );
    },
  },
  methods: {
    operationList(item) {
      const _list = [];

      // 详情
      if (this.AUTH_DOCS_ADD && hasReadWritePermission('read', 'wiki', item.readLevel)) {
        _list.push({
          id: 1,
          name: this.$t('docs_props'),
          event: () => {
            this.$router.push({ name: 'DocsProps', params: { id: item.id } });
          },
        });
      }

      // 编辑
      if (this.AUTH_DOCS_EDIT && hasReadWritePermission('write', 'wiki', item.writeLevel)) {
        _list.push({
          id: 2,
          name: this.$t('docs_form_edit_prop_title'),
          event: () => {
            this.$router.push({ name: 'DocsPropsUpdate', params: { id: item.id } });
          },
        });
      }

      // 禁用
      if (
        this.AUTH_DOCS_ENABLE_DISABLE &&
        hasReadWritePermission('write', 'wiki', item.writeLevel) &&
        // 已启用，显示禁用
        item.enable
      ) {
        _list.push({
          id: 3,
          name: this.$t('docs_disable'),
          event: () => {
            this.disabledDocument({
              params: { id: item.id, enable: !item.enable },
              name: item.title,
              callback: () => {
                this.getDocumentsList();
              },
            });
          },
        });
      }

      // 启用
      if (
        this.AUTH_DOCS_ENABLE_DISABLE &&
        hasReadWritePermission('write', 'wiki', item.writeLevel) &&
        // 已禁用，显示启用
        !item.enable
      ) {
        _list.push({
          id: 3,
          name: this.$t('docs_enable'),
          event: () => {
            this.enableDocument({
              params: { id: item.id, enable: !item.enable },
              name: item.title,
              callback: () => {
                this.getDocumentsList();
              },
            });
          },
        });
      }

      // 删除
      if (this.AUTH_DOCS_DELETE && hasReadWritePermission('write', 'wiki', item.writeLevel)) {
        _list.push({
          id: 3,
          name: this.$t('com_btn_delete'),
          event: () => {
            this.deleteDocument({
              params: { id: item.id },
              name: item.title,
              callback: () => {
                this.getDocumentsList(true);
              },
            });
          },
        });
      }

      // 分享
      if (hasReadWritePermission('read', 'wiki', item.readLevel)) {
        _list.push({
          id: 3,
          name: this.$t('com_btn_share'),
          event: () => {
            this.$refs.share.show(true, item);
          },
        });
      }

      return _list;
    },

    // 获取表单数据
    getData() {
      const _list = [this.getDetail(), this.getDocumentsList()];

      Promise.all(_list).finally(() => {
        // 全部接口返回时，清除loading
        this.$store.commit('setPageLoading', false);

        // 获取当前分类信息
        this.getCategoryInfo();
      });
    },

    // 获取文档详情
    getDetail(id) {
      if (id) {
        this.id = id;
        this.loadingContent = true;
      }
      return DocsAPI.getDocumentDetail({ id: this.id })
        .then(res => {
          if (res.code === 0 && res.data) {
            const _data = res.data;
            const _content = _data?.content?.replace(/\+/g, ' ') || '';
            this.detail = res.data || {};
            this.detail.content = _content;

            // 对内容进行处理
            const content = decodeURIComponent(_content);

            (async () => {
              // 获取图片的访问URL
              const parser = new DOMParser();
              const doc = parser.parseFromString(content, 'text/html');

              // 查找所有带有 data-src="image" 的 img 标签
              const images = doc.querySelectorAll('img[data-src="image"]');
              for (const img of images) {
                const url = await generateSignedUrl({ objectKey: img.src }); // Resolve src URL
                img.src = url;
              }

              // 查找所有带有 data-src="video" 的 video 标签
              const videos = doc.querySelectorAll('video[data-src="video"]');
              for (const video of videos) {
                // 处理 video 的 src 属性
                if (video.src) {
                  const url = await generateSignedUrl({ objectKey: video.src }); // Resolve src URL
                  video.src = url; // Replace with the signed URL
                }

                // 处理 video 内的 source 标签
                const sources = video.querySelectorAll('source');
                for (const source of sources) {
                  if (source.src) {
                    const url = await generateSignedUrl({ objectKey: source.src }); // Resolve src URL
                    source.src = url;
                  }
                }
              }

              this.form = {
                content: doc.body.innerHTML,
              };
            })();
          }
        })
        .catch(() => {
          this.detail = null;
          this.form = {
            content: undefined,
          };
        })
        .finally(() => {
          this.loadingContent = false;
        });
    },

    // 获取当前分类信息
    getCategoryInfo() {
      return DocsAPI.getCategoryDetail({ id: this.categoryId })
        .then(res => {
          if (res.code === 0 && res.data) {
            this.categoryInfo = res.data;
          }
        })
        .catch(() => {
          this.categoryInfo = null;
        });
    },

    // 获当前分类下的所有文档
    getDocumentsList(isDelete) {
      return DocsAPI.getAllDocumentByCategory({ wcId: this.categoryId })
        .then(res => {
          if (res.code === 0 && res.data) {
            this.list = res.data;
            // 把当前的ID放在第一个
            this.list.sort((a, _b) => {
              if (a.id === this.id) {
                return -1;
              }
              return 0;
            });

            this.listAll = res.data;

            if (isDelete) {
              // 删除后，重新获取详情
              if (this.list[0]) {
                this.$router.replace({
                  name: 'DocsContentUpdate',
                  params: { id: this.list[0].id, categoryId: this.categoryId },
                  key: new Date().getTime(),
                });
              } else {
                // 返回列表
                this.$router.push({
                  name: 'DocsList',
                });
              }
            }
          }
        })
        .catch(() => {
          this.list = null;
        });
    },

    // 搜索
    onSearch(value) {
      if (!value) {
        this.list = this.listAll;
        return;
      }
      this.list = this.listAll.filter(item => item.title.includes(value));
    },
    // 搜索
    onChange(e) {
      const _value = e.target.value || '';
      if (!_value) {
        this.list = this.listAll;
        return;
      }

      this.list = this.listAll.filter(item => item.title.includes(e.target.value));
    },

    // 保存
    save() {
      this.$confirm({
        title: this.$t('docs_form_content_save_confirm'),
        centered: true,
        onOk: () => {
          this.$refs.documentForm.validate(valid => {
            if (valid) {
              const _params = {
                id: this.id,
                content: this.form.content,
              };

              // 对content进行处理，
              const parser = new DOMParser();
              const doc = parser.parseFromString(this.form.content, 'text/html');

              // 查找所有带有 data-src="image" 的 img 标签
              const images = doc.querySelectorAll('img[data-src="image"]');
              images.forEach(img => {
                const url = new URL(img.src); // 解析 src URL
                img.src = url.pathname; // 替换为相对地址（pathname 部分）
              });

              // 查找所有带有 data-src="video" 的 video 标签
              const videos = doc.querySelectorAll('video[data-src="video"]');
              videos.forEach(video => {
                if (video.src) {
                  const url = new URL(video.src); // 解析 src URL
                  video.src = url.pathname; // 替换为相对地址（pathname 部分）
                }
                // 处理 video 内的 source 标签
                const sources = video.querySelectorAll('source');
                sources.forEach(source => {
                  if (source.src) {
                    const url = new URL(source.src); // 解析 source 的 src URL
                    source.src = url.pathname; // 替换为相对地址（pathname 部分）
                  }
                });
              });

              _params.content = doc.body.innerHTML;

              // 保存
              DocsAPI.saveDocumentContent(_params)
                .then(res => {
                  if (res.code === 0) {
                    this.$message.success(this.$t('com_msg_save_success'));
                  }
                })
                .catch(() => {
                  this.$message.error(this.$t('com_msg_save_fail'));
                });
            }
          });
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.docs-content {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  justify-content: space-between;
  background: @g-layout-background;
  gap: 12px;
  height: 100%;

  .docs-content-left {
    display: flex;
    width: 320px;
    flex-direction: column;
    align-items: flex-start;
    align-self: stretch;
    height: 100%;
    background: #fff;
    border-radius: 12px;

    .docs-content-left-title {
      padding: 20px 5px 15px 24px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      span {
        margin-right: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        svg {
          width: 24px;
          height: 24px;
        }
      }
      strong {
        color: #18181a;
        font-size: 16px;
        font-style: normal;
        font-weight: 600;
        flex: 1;
      }
    }

    // 搜索
    .docs-content-search {
      padding: 0 12px 6px 24px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 100%;
      gap: 12px;

      > span {
        display: flex;
        align-items: center;
        justify-content: center;
        a {
          display: flex;
          align-items: center;
          justify-content: center;
        }
        svg {
          width: 36px;
          height: 36px;
        }
      }
    }

    // 列表
    .docs-content-list {
      width: 100%;
      padding: 12px 0;
      height: calc(100% - 95px);
      overflow-y: auto;
      ul {
        margin: 0;
        padding: 0 5px;
        li {
          width: 100%;
          color: #18181a;
          font-size: 14px;
          font-style: normal;
          font-weight: 400;
          display: flex;
          align-items: center;
          justify-content: space-between;
          border-radius: 3px;
          padding: 10px 0;
          margin: 10px 0;

          &.active {
            background: #e6e7f8;
            span {
              color: #1838d9;
              font-weight: 600;
              background: #e6e7f8;
              border-radius: 4px 0 0 4px;
            }

            button {
              color: #1838d9;
              background: #e6e7f8;
              border-radius: 0 4px 4px 0;
            }

            &:hover {
              background: #e6e7f8;
            }
          }

          &:hover {
            cursor: pointer;
            color: #1838d9;
            background: #f9f9f9;

            button,
            span {
              color: #1838d9;
            }
          }

          button,
          span {
            padding: 0 19px;
            color: #18181a;
            font-size: 14px;
            font-style: normal;
            font-weight: 400;
            text-decoration: none;
            height: 100%;
            border-radius: 0;
          }

          span {
            flex: 1;
            display: flex;
            align-items: center;
          }
        }
      }
    }
  }

  .docs-content-right {
    display: flex;
    padding: 24px;
    flex: 1 0 0;
    align-self: stretch;
    min-height: 100%;
    background: #fff;
    border-radius: 12px;
    overflow-y: hidden;

    .docs-content-title {
      display: flex;
      padding-bottom: 16px;
      justify-content: space-between;
      align-items: center;
      align-self: stretch;
      background: #fff;
      gap: 12px;

      h3 {
        margin: 0;
        border: none;
        width: 70%;
        font-weight: 600;
        color: #333;
        font-size: 24px;

        &:focus {
          border: none;
          box-shadow: none;
        }
      }
      .docs-content-title-action {
        width: 120px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        gap: 12px;
      }
    }

    .docs-content-content {
      height: calc(100% - 60px);
    }
  }

  ::v-deep .docs-content-tinymce {
    width: 100%;
    height: 100%;
    .ant-form-item-control-wrapper {
      height: 100%;
      .ant-form-item-control {
        height: 100%;
        .ant-form-item-children {
          height: 100%;
          .ant-input {
            height: 100%;
          }
          .tox-tinymce {
            height: 100% !important;
          }
        }
      }
    }
  }
}
</style>
